/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_nav_user_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Cerrar sesión`
};

const en_nav_user_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Log out`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const nav_user_logout = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nav_user_logout(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("nav_user_logout", locale)
	if (locale === "es") return es_nav_user_logout(inputs)
	return en_nav_user_logout(inputs)
};
export { nav_user_logout as "nav_user.logout" }